import React from 'react';

/** A bordered pane — the list/detail halves of a split view. */
export default function EtlPane({ title, actions, flush = false, className, children }) {
  return (
    <section className={`ep-pane${className ? ` ${className}` : ''}`}>
      {(title || actions) ? (
        <header className="ep-pane-head">
          {title ? <h3>{title}</h3> : null}
          <div className="cp-toolbar-spacer" />
          {actions}
        </header>
      ) : null}
      <div className={flush ? '' : 'ep-pane-body'}>{children}</div>
    </section>
  );
}

/** Read-only key/value rows for detail panes. rows: [{ label, value, mono? }] */
export function EtlKv({ rows = [] }) {
  const shown = rows.filter((r) => r && r.value != null && r.value !== '');
  if (!shown.length) return null;
  return (
    <dl className="ep-kv">
      {shown.map((r) => (
        <React.Fragment key={r.label}>
          <dt>{r.label}</dt>
          <dd className={r.mono ? 'ep-mono' : undefined}>{r.value}</dd>
        </React.Fragment>
      ))}
    </dl>
  );
}
